// db/roomManager.ts
import {
  registerMutation,
  registerQuery,
  registerSubscription,
  registerUnion
} from "@adornis/baseql/metadata/register.js";
import "@adornis/baseql/utils/queryGeneration.js";
import { of } from "rxjs";
import { getMemberID } from "../server/resolver/memberID.js";
import {
  getRoom as getRoomResolver,
  joinRoomResolver,
  leaveRoomResolver,
  subscribeAllActiveRoomsResolver
} from "../server/resolver/room.js";
import { Room } from "./room.js";
import { Signal } from "./signals.js";
var getOwnRoomIndentifier = registerQuery({
  operationName: "getOwnRoomIdentifier",
  resolve: () => () => getMemberID(),
  type: () => String
});
var getRoom = registerQuery({
  operationName: "getRoom",
  resolve: (roomID) => (gqlFields) => getRoomResolver(roomID),
  type: () => Room,
  params: [{ name: "roomID", type: () => String }]
});
var subscribeRoom = registerSubscription({
  operationName: "subscribeRoom",
  resolve: (roomID) => (gqlFields) => getRoomResolver(roomID)?.whenChanging ?? of(void 0),
  type: () => Room,
  params: [{ name: "roomID", type: () => String }]
});
var subscribeAllActiveRooms = registerSubscription({
  operationName: "subscribeAllActiveRooms",
  resolve: subscribeAllActiveRoomsResolver,
  type: () => [Room]
});
var RoomOrSignal = registerUnion({ name: "RoomOrSignal", types: () => [Room, Signal] });
var joinRoom = registerSubscription({
  operationName: "joinRoom",
  resolve: joinRoomResolver,
  type: () => RoomOrSignal,
  params: [
    { name: "roomID", type: () => String },
    { name: "ignoreDuplicateIdentifier", type: () => Boolean }
  ]
});
var leaveRoom = registerMutation({
  operationName: "leaveRoom",
  resolve: (roomID) => async () => {
    const memberID = getMemberID();
    return leaveRoomResolver(roomID, memberID);
  },
  type: () => Boolean,
  params: [{ name: "roomID", type: () => String }]
});
export {
  RoomOrSignal,
  getOwnRoomIndentifier,
  getRoom,
  joinRoom,
  leaveRoom,
  subscribeAllActiveRooms,
  subscribeRoom
};
